import type { RootState } from "app/redux/slices/rootReducer";

export const selectIdleState = (state: RootState) => state.idleSlice.idleState;
export const selectConversationStartedAt = (state: RootState) =>
  state.idleSlice.conversationStartedAt;
